import { Controller } from "@hotwired/stimulus";

import updateSelectOptions from "./updateSelectOptions";

export default class extends Controller {
  select;

  connect() {
    this.handleChange = this.handleChange.bind(this);
    this.select = this.element.querySelector("select");
    this.select.addEventListener("change", this.handleChange);
  }

  disconnect() {
    this.select.removeEventListener("change", this.handleChange);
  }

  handleChange() {
    const name = this.select.name;
    const provinceId = this.select.value;
    const cantonFieldName = name.replace("province_id", "canton_id");
    const cantonsSelect = this.select.form.querySelector(
      `[name="${cantonFieldName}"]`
    );
    if (cantonsSelect) {
      fetch(`/cantons.json?q[province_id_eq]=${provinceId}`)
        .then((response) => response.json())
        .then((cantons) => {
          updateSelectOptions(cantonsSelect, cantons);
        });
    }
  }
}
